import { Plus } from "lucide-react";
import React, { useState } from "react";
import TopNavbar from "../../components/AdminPortal/TopNavbar";
import { useSidebar } from "../../context/SidebarContext";
import "../../global.css";
import Announcement from "../../components/Announcement";
import OfficeNoticeBoard from "../../components/OfficeNoticeBoard";
import Dashboard from "./Dashboard";
// import TeamMessaging from "../../components/TeamMessaging";

const NewDashboard = () => {
  const { sidebarExpanded, isMobile } = useSidebar();
  const [activeTab, setActiveTab] = useState("dashboard");
  return (
    <div
      className="min-h-screen bg-black text-white   mt-12"
      style={{
        marginLeft: isMobile ? "0" : sidebarExpanded ? "200px" : "60px",
        width: isMobile
          ? "100%"
          : `calc(100% - ${sidebarExpanded ? "200px" : "60px"})`,
      }}
    >
      <TopNavbar />
      <div className="p-4 md:p-6">
        <div className="tab-strip-border overflow-x-auto scrollbar-hide">
          <div className="flex">
            <button
              onClick={() => setActiveTab("dashboard")}
              className={`tab-button ${
                activeTab === "dashboard"
                  ? "active-tab-border" // Apply the active border class
                  : "inactive-tab" // Apply inactive tab class
              }`}
            >
              Dashboard
            </button>
            <button
              onClick={() => setActiveTab("Announcement")}
              className={`tab-button ${
                activeTab === "Announcement"
                  ? "active-tab-border" // Apply the active border class
                  : "inactive-tab" // Apply inactive tab class
              }`}
            >
              Announcement
            </button>
            <button
              onClick={() => setActiveTab("OfficeNoticeBoard")}
              className={`tab-button ${
                activeTab === "OfficeNoticeBoard"
                  ? "active-tab-border" // Apply the active border class
                  : "inactive-tab" // Apply inactive tab class
              }`}
            >
              Office Notice Board
            </button>
            {/* <button
              onClick={() => setActiveTab("TeamMessaging")}
              className={`tab-button ${
                activeTab === "TeamMessaging"
                  ? "active-tab-border"
                  : "inactive-tab"
              }`}
            >
              Team Messaging
            </button> */}
          </div>
        </div>

        
      </div>
      {activeTab === "dashboard" ? (
         <Dashboard />
        ) : activeTab === "Announcement" ? (
          <Announcement />
        ) : activeTab === "OfficeNoticeBoard" ? (
          <OfficeNoticeBoard />
        ) : activeTab === "TeamMessaging" ? (
          <TeamMessaging />
        ) : null}
    </div>
  );
};

export default NewDashboard;
